import React, { Component } from 'react';
import styles from './registration.css';
import { Select } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendRegistrationForm, sendRegistrationFormAfterHatch } from 'data/player/register/actions';
import { requestPlayerByEmail } from 'data/player/register/api';
import URLSearchParams from 'url-search-params';
import { getSwitchClassNameOrColourWithBackground, wrapUrlByTag } from '../../../../../../../utils/func';

const mapStateToProps = ( { reguser, localization: { content } } ) => ( { reguser, content } );

const mapDispatchToProps = dispatch => ( {
    actions: bindActionCreators( {
        sendRegistrationForm,
        sendRegistrationFormAfterHatch
    }, dispatch )
} );

@connect( mapStateToProps, mapDispatchToProps )
class Registration extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            messages: {
                isEmpty: 'This field can not be empty!',
                wrongEmail: 'Wrong Email format!',
                shortLength: 'This field cannot be shorter than',
                figures: 'symbols!'
            },
            player: null,
            registrationFields: {
                name: '',
                email: '',
                terms: null,
                key: null,
                calendar_id: null,
                item: null,
                regsource_id: null,
                regsource_type: '',
                fieldCounter: 0
            },
            additional_info: {}
        };

        this.requiredFields = {
            name: {
                input: React.createRef(),
            },
            email: {
                input: React.createRef(),
            }
        };

        this.divBlock = null;
    };

    componentDidMount() {
        const { hatchId } = this.props;
        window.onresize = () => {
            this.forceUpdate();
        };

        let randomEmail;

        randomEmail = null;

        this.props.regHeight( this.divBlock.offsetHeight );

        let keyParams = null;
        if ( this.props.location ) {
            const params = new URLSearchParams( this.props.location.search );
            keyParams = params.get( 'key' );
        }
        this.setState( {
            ...this.registrationFields,
            registrationFields: {
                ...this.state.registrationFields,
                key: keyParams,
                calendar_id: this.props.calendar.id,
                item: 'calendar',
                regsource_id: this.props.calendar.id,
                regsource_type: 'calendar',
                hatchId: hatchId,
                email: randomEmail,
                name: ''
            },
        } );
    };

    componentDidUpdate(prevProps ) {
        const { startPlay, calendar: { registration_settings }, showResultView, reguser: { top_list: prevTopList }, currentView } = prevProps;
        const {
            reguser: { top_list: currentTopList } // Extract top_list from this.props.reguser
          } = this.props;

        if ( prevTopList !== currentTopList && Object.keys( this.props.reguser ).length !== 0 && this.props.reguser.constructor === Object && registration_settings.enabled) {
            if ( registration_settings.appearance === 'before' ) {
                if( currentView === 'result') {
                    showResultView( this.props.reguser );
                } else {
                    startPlay();
                }
            } else if ( registration_settings.appearance === 'after' ) {
                showResultView( this.props.reguser );
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps && nextProps.reguser && nextProps.reguser.top_list && nextProps.reguser.top_list.length > 0 &&
            nextProps.reguser.top_list !== this.props.reguser.top_list){
            this.props.parentCallback(
                nextProps.reguser.top_list
            );
        }
    }

    renderAdditionalFields = () => {
        const { calendar: { registration_form } } = this.props;

        let additionalFields = [];

        if ( registration_form ) {
            const registrationForm = JSON.parse( registration_form );
            if ( registrationForm.defaultFields && registrationForm.customFields ) {
                additionalFields = registrationForm.defaultFields.concat( registrationForm.customFields );
            } else if ( registrationForm.defaultFields ) {
                additionalFields = registrationForm.defaultFields;
            } else if ( registrationForm.customFields ) {
                additionalFields = registrationForm.customFields;
            }


            additionalFields = additionalFields.map( (dField ,id )=> {
                if ( dField.alias !== 'terms' ) {
                    return this.renderFieldByType( dField, id );
                } else {
                    this.state.registrationFields.terms = true;
                    this.requiredFields.terms = {
                        input: React.createRef(),
                        label: React.createRef()
                    };
                }
            } );
        }
        if ( this.state.fieldCounter !== additionalFields.length - 1 ) {
            this.setState( { fieldCounter: additionalFields.length - 1 } );
        }
        return additionalFields;
    };

    convertToSelectOptions = ( dropdownOptions ) => {
        const arr = ( dropdownOptions + '' ).replace( '";"', ';' ).split( ';' ).map( opt => opt.trim() );
        const firstEmpty = [ { text: ' ', value: '' } ];
        return firstEmpty.concat( arr.map( option => ( { text: option, value: option } ) ) );
    };

    validateDropDownField = ( e ) => {
        if ( e.target.innerText !== '' ) {
            e.target.parentElement.style.background =  'rgba(255, 255, 255, 0.5)';
        } else {
            e.target.parentElement.style.background = 'rgba(212, 75, 75, 0.5)';
        }
    };

    validateRadiobutton = ( e ) => {
        if ( e.target.value === 'on' ) {
            e.target.parentElement.parentElement.style.background = 'rgba(255, 255, 255, 0.5)';
        } else {
            e.target.parentElement.parentElement.style.background = 'rgba(212, 75, 75, 0.5)';
        }
    };

    validateField = ( e ) => {

        const { messages: { isEmpty, wrongEmail, shortLength, figures } } = this.state;

        if ( e.target.type === 'email' && e.target.value === '' ) {
            if (e.target.labels[0]) {
                e.target.labels[0].style = 'display:block';
                e.target.labels[0].innerHTML = isEmpty;
            }
            e.target.style.background = 'rgba(212, 75, 75, 0.5)';
            return false;
        }

        if ( e.target.type === 'email' && !this.validateEmailString( e.target.value ) ) {
            e.target.labels[ 0 ].style = 'display:block';
            e.target.labels[ 0 ].innerHTML = wrongEmail;
            e.target.style.background = 'rgba(212, 75, 75, 0.5)';
            return false;
        }

        if ( e.target.value !== '' ) {
            e.target.style.background =  'rgba(255, 255, 255, 0.5)';
            if (e.target.labels[0]) {
                e.target.labels[0].style = 'display:none';
                e.target.labels[0].innerHTML = isEmpty;
            }
            return true;
        } else {
            if (e.target.labels[0]) {
                e.target.labels[ 0 ].style = 'display:block';
                e.target.labels[ 0 ].innerHTML = isEmpty;
            }
            e.target.style.background = 'rgba(212, 75, 75, 0.5)';
            return false;
        }
    };


    renderFieldByType = (field, id) => {
        const { calendar: { settings }, content } = this.props;
        const backgroundColor = getSwitchClassNameOrColourWithBackground( settings.appearance.inner_background, 'rgba(0, 0, 0, 0.1)', 'rgba(255, 255, 255, 0.5)' );
        const dropBoxColorTheme = getSwitchClassNameOrColourWithBackground( settings.appearance.inner_background, styles.darkDropBox, styles.dropBox );

        switch ( field.fieldType ) {
            case 'text':
            case 'number': {
                if ( field.required ) {
                    this.requiredFields[ field.alias ] = {
                        input: React.createRef()
                    };
                }

                return <input
                    key={ id }
                    onBlur={ ( e ) => field.required && this.validateField( e ) }
                    style={ { backgroundColor: backgroundColor } }
                    className={ styles.textInput }
                    type={ field.fieldType }
                    value={ this.state.additional_info[ field.alias ] }
                    placeholder={ field.required
                        ? `${ field.alias.toLowerCase() === 'phone'
                            ? content.calendar.phone
                            : field.alias.toLowerCase() === 'age'
                                ? content.calendar.age
                                : field.alias.toLowerCase() === 'city'
                                    ? content.calendar.city
                                    : field.alias.toLowerCase() === 'address'
                                        ? content.calendar.address
                                        : field.alias.toLowerCase() === 'surname'
                                            ? content.calendar.surname
                                            : field.alias.toLowerCase() === 'username'
                                                ? content.calendar.username
                                                : field.label }*`
                        : field.alias.toLowerCase() === 'phone'
                            ? content.calendar.phone
                            : field.alias.toLowerCase() === 'age'
                                ? content.calendar.age
                                : field.alias.toLowerCase() === 'city'
                                    ? content.calendar.city
                                    : field.alias.toLowerCase() === 'address'
                                        ? content.calendar.address
                                        : field.alias.toLowerCase() === 'surname'
                                            ? content.calendar.surname
                                            : field.alias.toLowerCase() === 'username'
                                                ? content.calendar.username
                                                : field.label }
                    ref={ field.required && this.requiredFields[ field.alias ].input }
                    required={ field.required }
                    onChange={ e => this.additionalFieldChange( field.alias, e.target.value ) }
                    onKeyDown={ e => this.filterAgeInput( field.alias, e ) }
                />;
            }
            case 'checkbox': {
                if ( field.required ) {
                    this.requiredFields[ field.alias ] = {
                        input: React.createRef(),
                        label: React.createRef()
                    };
                }

                return <div key={ id } className={ styles.checkboxWrapper }>
                    <input
                        onBlur={ ( e ) => field.required && this.validateField( e ) }
                        type='checkbox'
                        style={ { color: settings.appearance.font_style ? settings.appearance.font_style.color : 'rgb(52, 51, 51)' } }
                        className={ styles.customCheckbox }
                        checked={ this.state.additional_info[ field.alias ] }
                        ref={ field.required && this.requiredFields[ field.alias ].input }
                        required={ field.required }
                        onChange={ e => this.additionalFieldChange( field.alias, e.target.checked ) }
                    />
                    <label
                        dangerouslySetInnerHTML={ { __html: wrapUrlByTag( field.required ? `${ field.label }*` : field.label ) } }
                        className={ styles.labelCheckbox }
                        htmlFor={ field.alias }
                        ref={ field.required && this.requiredFields[ field.alias ].label }
                    />

                </div>;

            }
            case 'radio': {
                if ( field.required ) {
                    this.requiredFields[ field.alias ] = {
                        input: React.createRef(),
                        label: React.createRef(),
                        isRadio: true
                    };
                }


                return <div key={ id } className={ styles.radioWrapper }>
                    <form className={ styles.radioOptionsList }
                          ref={ field.required && this.requiredFields[ field.alias ].input }
                    >

                        { this.convertToSelectOptions( field.options ).slice( 1 ).map( ( option, index ) =>
                            <div key={ index } className={ styles.radioBox }   >
                                <input

                                    onBlur={ ( e ) => field.required && this.validateRadiobutton( e ) }
                                    id={ field.alias + option }
                                    className={ styles.checkInput }
                                    type={ field.fieldType }

                                    name={ field.alias }
                                    placeholder={ option.text }
                                    onChange={ e => this.additionalFieldChange( field.alias, e.target.value ) }
                                />
                                <label
                                    htmlFor={ field.alias + option }>
                                    { option.text }

                                </label>
                            </div> ) }
                    </form>
                </div>;
            }

            case 'dropdown': {

                if ( field.required ) {

                    this.requiredFields[ field.alias ] = {
                        input: React.createRef(),
                        label: React.createRef(),
                        isDropdown: true
                    };
                }
                return (
                    <div key={ id } className={ styles.dropWrapper }>
                        <div
                            ref={ field.required && this.requiredFields[ field.alias ].input }
                            className={ `${ dropBoxColorTheme }  ` }>
                            <Select
                                onBlur={ ( e ) => field.required && this.validateDropDownField( e ) }
                                placeholder={ field.label }
                                onChange={ ( event, params ) => this.additionalFieldChange(  field.alias , params.value ) }
                                options={ this.convertToSelectOptions( field.dropdownOptions ) }
                            />

                        </div>

                    </div>
                );
            }
            default:
                return null;
        }
    };


    additionalFieldChange = ( name, value ) => {
        this.setState( {
            additional_info: {
                ...this.state.additional_info,
                [ name ]: value
            }
        } );
    };


    filterAgeInput = ( name, e ) => {
        if ( name === 'age' ) {
            e = e || window.event;
            let charCode = ( typeof e.which == 'undefined' ) ? e.keyCode : e.which;
            let charStr = String.fromCharCode( charCode );
            if ( charCode !== 8 ) {
                if ( !charStr.match( /^[0-9]+$/ ) )
                    e.preventDefault();
            } else return;
        } else return;
    };


    handleRegistration = () => {
        const { registrationFields } = this.state;
        const { actions: { sendRegistrationForm, sendRegistrationFormAfterHatch }, calendar: { registration_settings } } = this.props;

        if ( this.invalidFields() ) {
            this.setState( {
                registrationFields: {
                    ...registrationFields,
                    additional_info: JSON.stringify( this.state.additional_info )
                }
            }, () => {
                registration_settings.appearance === 'before' ?
                    sendRegistrationForm( this.state.registrationFields )
                    :
                    sendRegistrationFormAfterHatch( this.state.registrationFields );

            } );
        }
    };

    checkPlayer = e => {
        const { calendar: { id } } = this.props;
        requestPlayerByEmail( e.target.value, id ).then( player => {
            if ( player ) {
                let additionalInfo = JSON.parse( player.additional_info );
                this.setState( {
                    registrationFields: {
                        ...this.registrationFields,
                        name: player.name,
                        email: player.email,

                    },
                    additional_info: { ...additionalInfo }
                } );
                this.setState( { player } );
            }

        } );
    };

    validateEmailString = ( string ) => {
        const validRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.)+[a-zA-Z0-9-]+$/i;
        return validRegex.test( string );
    }

    invalidFields = () => {
        const requiredFields = this.requiredFields;
        const listOfUnvalidFields = Object
            .keys( requiredFields )
            .filter( key => {


                if ( requiredFields[ key ]?.input?.current.type === 'text' ) {
                    const isChecked = requiredFields[ key ].input.current.value !== '';
                    isChecked ?
                        requiredFields[ key ].input.current.style.background = 'rgba(255, 255, 255, 0.5)'
                        : requiredFields[ key ].input.current.style.background = 'rgba(212, 75, 75, 0.5)';
                    return !isChecked;
                } else if ( requiredFields[ key ]?.input?.current.type === 'email' ) {
                    const isChecked = requiredFields[ key ].input.current.value !== '' && this.validateEmailString(requiredFields[ key ].input.current.value);
                    isChecked ?
                        requiredFields[ key ].input.current.style.background = 'rgba(255, 255, 255, 0.5)'
                        : requiredFields[ key ].input.current.style.background = 'rgba(212, 75, 75, 0.5)';
                    return !isChecked;
                } else if ( requiredFields[ key ]?.input?.current.type === 'checkbox' ) {
                    const isChecked = requiredFields[ key ].input.current.checked;
                    isChecked ?
                        requiredFields[ key ].input.current.offsetParent.style.background = 'rgba(255, 255, 255, 0.5)'
                        : requiredFields[ key ].input.current.offsetParent.style.background = 'rgba(212, 75, 75, 0.5)';
                    return !isChecked;
                } else if ( !requiredFields[ key ].hasOwnProperty( 'isDropdown' ) && !requiredFields[ key ].hasOwnProperty( 'isRadio' )
                    && requiredFields[ key ].input.current.checkValidity() ) {
                    requiredFields[ key ].input.current.style.background = 'rgba(255, 255, 255, 0.5)';
                    requiredFields[ key ].label && ( requiredFields[ key ].label.current.style.color = '#fff' );
                    return false;

                } else if ( requiredFields[ key ].hasOwnProperty( 'isDropdown' ) ) {
                    const isTextExist = typeof this.state.additional_info[ key ] === 'string';
                    const isTextLength = isTextExist && this.state.additional_info[ key ].length;
                    const isDropdownEmpty = !( isTextExist && isTextLength );
                    requiredFields[ key ].input.current.style.background = isDropdownEmpty ? 'rgba(212, 75, 75, 0.5)' : 'transparent';
                    return isDropdownEmpty;

                } else if ( requiredFields[ key ].hasOwnProperty( 'isRadio' ) ) {
                    const isChecked = Array.prototype.some.call( requiredFields[ key ].input.current.elements, ( el ) => ( el.checked ) );
                    isChecked ?
                        requiredFields[ key ].input.current.style.background = 'transparent'
                        : requiredFields[ key ].input.current.style.background = 'rgba(212, 75, 75, 0.5)';
                    return !isChecked;
                } else {
                    requiredFields[ key ].input.current.style.background = 'rgba(212, 75, 75, 0.5)';
                    requiredFields[ key ].label && ( requiredFields[ key ].label.current.style.color = 'rgba(212, 75, 75, 0.5)' );
                    return true;
                }
            } );

        return listOfUnvalidFields.length === 0;

    };

    onSkip = (appearance) => {
        const { beforeSkipClicked,afterSkipClicked } = this.props;
        if(appearance === 'before'){
            beforeSkipClicked(this.props.reguser);
        }else {
        afterSkipClicked();
        }
    };
    
    render() {
        const { content, calendar, calendar: { registration_settings }, fontFamilyH2 } = this.props;
        const backgroundColor = getSwitchClassNameOrColourWithBackground( calendar.settings.appearance.inner_background, 'rgba(0, 0, 0, 0.1)', 'rgba(255, 255, 255, 0.5)' );
        const { fieldCounter } = this.state;
        const textAutoColorClass = getSwitchClassNameOrColourWithBackground( calendar.settings.appearance.background_color, 'lightBgPlaceholder', 'darkBgPlaceholder' );
        let widthPop = window.innerHeight + 'px' + ' - 15rem';
        widthPop = { height: widthPop };

        return (
            <div style={ { widthPop } }
                 className={ styles.registrationPopup }
                 ref={ div => this.divBlock = div }>
                <h2 style={ fontFamilyH2 }
                    className={ styles.title }>
                    { content.calendar.registration }
                </h2>
                { registration_settings.reg_cust_text ?
                    <p className={ styles.subtitle }
                       dangerouslySetInnerHTML={ { __html: wrapUrlByTag( registration_settings.reg_cust_text ) } }/>

                    : <p className={ styles.subtitle }>
                        <span>{ content.calendar.fill_your_details_see_your_results }</span>
                    </p> }
                <div className={ styles.inputFields }
                     style={ fieldCounter > 46
                         ? { maxHeight: '110rem' }
                         : fieldCounter > 34
                             ? { maxHeight: '90rem' }
                             : fieldCounter > 25
                                 ? { maxHeight: '70rem' }
                                 : fieldCounter > 13
                                     ? { maxHeight: '50rem' }
                                     : {} }
                >

                    <input
                        onBlur={ ( e ) => this.validateField( e ) }
                        style={ { backgroundColor: backgroundColor } }
                        className={ styles.textInput }
                        type={ 'text' }
                        id={ 'input-1' }
                        ref={ this.requiredFields.name.input }
                        pattern={ '[^@]*' }
                        placeholder={ content.calendar.name_star }
                        value={ this.state.registrationFields.name }
                        required={ true }
                        onChange={ e => this.setState( {
                            registrationFields: {
                                ...this.state.registrationFields,
                                name: e.target.value
                            }
                        } ) }
                    />
                    <label className={ styles.informationLabel } htmlFor='input-1'/>

                    <input
                        onBlur={ ( e ) => this.validateField( e ) }
                        style={ { backgroundColor: backgroundColor } }
                        className={ styles.textInput }
                        type={ 'email' }
                        id={ 'email-1' }
                        pattern={ '[^@]+@[^@]+\\.[a-zA-Z]{2,6}' }
                        ref={ this.requiredFields.email.input }
                        placeholder={ content.calendar.email_star }
                        required={ true }
                        value={ this.state.registrationFields.email }
                        onChange={ e => this.setState( {
                            registrationFields: {
                                ...this.state.registrationFields,
                                email: e.target.value.toLowerCase().trim()
                            }
                        } ) }
                    />
                    <label className={ styles.informationLabel } htmlFor='email-1'/>

                    { this.renderAdditionalFields() }
                </div>
                <div className={ styles.registrationFooter }>
                    { this.state.registrationFields.terms && this.requiredFields.terms &&
                    <div>
                        <input
                            ref={ this.requiredFields.terms.input }
                            type={ 'checkbox' }
                            required={ true }/>
                        <label ref={ this.requiredFields.terms.label }>
                            <a className={ styles.linkTerm }
                               style={ { textDecoration: calendar.registration_settings.terms ? 'underline' : '' } }
                               href={ calendar.registration_settings.terms }
                               target='_blank'>
                                { content.calendar.agree_with_terms_star }
                            </a>
                        </label>
                    </div>
                    }
                    <p className={ styles.requiredFields }>* { content.required_fields }</p>
                    <button
                        style={ calendar && { ...calendar.settings.appearance.button_style } }
                        className={ styles.submitButton }
                        aria-label={ content.calendar.register_aria_label }
                        onClick={ this.handleRegistration }>
                        { content.calendar.register }
                    </button>
                    { !!registration_settings && !!registration_settings.skip_btn_enabled &&
                        <button
                            onClick={ () => {
                                this.onSkip(registration_settings.appearance);
                            } }
                            aria-label={ content.registration.skip_aria_label }
                            className={ `${ styles.skipBtn } ${ styles[ textAutoColorClass ] }` }>
                            { content.registration.skip || 'Skip' }
                        </button>
                    }
                </div>
            </div>
        );
    };
}

export default Registration;